export default "__VITE_ASSET__kACym_xY__"